import React from "react";
import useAuth from "../hooks/UseAuth";
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, user, initialized } = useAuth();

  if (!initialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (!isLoggedIn || !user) {
    return <Navigate to="/"  />;
  }

  if (window.location.pathname.startsWith("/psikotes/") && user.status_tes === "Completed Test") {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedRoute;
